import {NgModule} from '@angular/core';
import {UiBasicModule} from './components/basic/ui-basic.module';
import {UiAdvancedModule} from './components/complex/ui-advanced.module';


@NgModule({
    exports: [
        UiBasicModule,
        UiAdvancedModule
    ],
    imports: [
        UiBasicModule,
        UiAdvancedModule
    ]
})
export class UiModule {
}
